import { FrameErrorInformation } from "../../types/FrameErrorInformation";
import { createChannel } from "./createChannel";

// Create a type-safe iframe channel that notifies the parent frame when a user's code errors out.
const [frameErrorPublisher, frameErrorSubscriber] = createChannel<
  FrameErrorInformation
>({
  name: "code-cell-error",
  publisherOrigin: "*",
  subscriberOrigin: "*",
});

export { frameErrorPublisher, frameErrorSubscriber };
